module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"createDataset":"Créer un jeu de données"},"en":{"createDataset":"Create a dataset"}}')
  delete Component.options._Ctor
}
